import { useWalmartDisabledRedirect } from 'pages/loyalty/loyalty-partners/walmart/use-walmart-disabled-redirect';
import { WalmartRedirect } from 'pages/loyalty/loyalty-partners/walmart/walmart-redirect';

export default function WalmartRedirectPage() {
  const disabledRedirect = useWalmartDisabledRedirect();
  if (disabledRedirect) {
    return disabledRedirect;
  }
  return <WalmartRedirect />;
}
